import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import './index.css'

import App from './App'
import PrivateRoute from './PrivateRoute'
import Provision from './Provision'
import PrinterStatusDisplay from './PrinterStatusDisplay'

ReactDOM.render(
<BrowserRouter>
  <App>
    <Routes>
      <Route exact path="/printer_status_display" element={<PrivateRoute/>}>
        <Route exact path="/printer_status_display" element={<PrinterStatusDisplay/>}/>
      </Route>
      <Route exact path="/provision" element={<Provision/>} />
      <Route exact path="/" element={<Navigate to="/printer_status_display" />} />
    </Routes>
  </App>
</BrowserRouter>,
  document.getElementById('root')
)

